module.exports = __webpack_public_path__ + "static/media/header-dark.6bbc7bf6.svg";